import React, { createContext, useState, useCallback, useContext, useRef } from 'react';

export const NotificationContext = createContext();

let notificationId = 0;

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  const timersRef = useRef({});

  const removeNotification = useCallback((id) => {
    if (timersRef.current[id]) {
      clearTimeout(timersRef.current[id]);
      delete timersRef.current[id];
    }
    setNotifications((prev) => prev.filter((n) => n.id !== id));
  }, []);

  const addNotification = useCallback(
    (message, type) => {
      const id = ++notificationId;
      setNotifications((prev) => [...prev, { id, message, type }]);
      timersRef.current[id] = setTimeout(() => {
        removeNotification(id);
      }, 5000);
      return id;
    },
    [removeNotification]
  );

  const showSuccess = useCallback(
    (message) => addNotification(message, 'success'),
    [addNotification]
  );
  const showError = useCallback((message) => addNotification(message, 'error'), [addNotification]);
  const showInfo = useCallback((message) => addNotification(message, 'info'), [addNotification]);

  return (
    <NotificationContext.Provider
      value={{ notifications, showSuccess, showError, showInfo, removeNotification }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
};
